import { LiikkuvaWifiProductCode } from '../../../common/constants/subscriptionConstants';
import {
  FiveGMobileBroadbandProductCode,
  FiveGVoiceProductCode,
  MobileBroadbandFourGProductCodes,
  MobileM2MAddonCode,
  OldVoiceProductCode,
  VoiceYrityspuheLiteProductCode,
  YrityspakettiProductCode,
} from '../../../common/enums';
import {
  formatNumber,
  gBMoMsg,
  kBitsPerSecondMsg,
  mBitsPerSecondMsg,
  mBpsMsg,
  pcsMsg,
  t,
  unlimitedMsg,
} from '../../../common/i18n';

export interface ProductVariablesType {
  [key: string]: {
    localFupLimit?: () => string;
    euFupLimit?: () => string;
    uploadSpeed?: () => string;
    voiceLimit?: () => string;
    smsLimit?: () => string;
    downloadSpeed?: () => string;
  };
}

export const productVariables: ProductVariablesType = {
  [FiveGVoiceProductCode.Voice5gPlus1000Mbps]: {
    localFupLimit: () => t.MVTD(unlimitedMsg),
    euFupLimit: () => `80 ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBpsMsg, '100'),
    voiceLimit: () => '5000 min',
    smsLimit: () => `500 ${t.B3MG(pcsMsg)}`,
  },
  [FiveGVoiceProductCode.Voice5gPlus600Mbps]: {
    localFupLimit: () => t.MVTD(unlimitedMsg),
    euFupLimit: () => `${formatNumber(66.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBpsMsg, '75'),
    voiceLimit: () => '5000 min',
    smsLimit: () => `200 ${t.B3MG(pcsMsg)}`,
  },
  [FiveGVoiceProductCode.Voice5gPlus300Mbps]: {
    localFupLimit: () => t.MVTD(unlimitedMsg),
    euFupLimit: () => `${formatNumber(58.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBpsMsg, '50'),
    voiceLimit: () => '5000 min',
    smsLimit: () => `200 ${t.B3MG(pcsMsg)}`,
  },
  [FiveGVoiceProductCode.Voice50Mbps]: {
    localFupLimit: () => t.MVTD(unlimitedMsg),
    euFupLimit: () => `47 ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBpsMsg, '25'),
    voiceLimit: () => '100 min',
    smsLimit: () => `100 ${t.B3MG(pcsMsg)}`,
  },
  [FiveGVoiceProductCode.Voice10Mbps]: {
    localFupLimit: () => t.MVTD(unlimitedMsg),
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBpsMsg, '5'),
    voiceLimit: () => '100 min',
    smsLimit: () => `100 ${t.B3MG(pcsMsg)}`,
  },
  [FiveGMobileBroadbandProductCode.MBB_5G_PLUS_1000_M]: {
    euFupLimit: () => `80 ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '100'),
  },
  [FiveGMobileBroadbandProductCode.MBB_5G_PLUS_600_M]: {
    euFupLimit: () => `${formatNumber(66.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '75'),
  },
  [FiveGMobileBroadbandProductCode.MBB_5G_PLUS_300_M]: {
    euFupLimit: () => `${formatNumber(58.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '50'),
  },
  [FiveGMobileBroadbandProductCode.MBB_5G_PLUS_100_M]: {
    euFupLimit: () => `${formatNumber(46.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '50'),
  },
  [FiveGMobileBroadbandProductCode.MBB_50_M]: {
    euFupLimit: () => `36 ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '25'),
  },
  [FiveGMobileBroadbandProductCode.MBB_10_M]: {
    euFupLimit: () => `${formatNumber(24.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '5'),
  },
  [LiikkuvaWifiProductCode.MBB_1000_M]: {
    euFupLimit: () => `80 ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '100'),
  },
  [LiikkuvaWifiProductCode.MBB_600_M]: {
    euFupLimit: () => `${formatNumber(66.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '75'),
  },
  [LiikkuvaWifiProductCode.MBB_300_M]: {
    euFupLimit: () => `${formatNumber(58.5)} ${t.U54O(gBMoMsg)}`,
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '50'),
  },
  [MobileM2MAddonCode.S]: {
    downloadSpeed: () => t.B69Q(kBitsPerSecondMsg, '256'),
    uploadSpeed: () => t.B69Q(kBitsPerSecondMsg, '256'),
    euFupLimit: () => `5,5 ${t.U54O(gBMoMsg)}`,
  },
  [MobileM2MAddonCode.M]: {
    downloadSpeed: () => t.B69Q(kBitsPerSecondMsg, '256'),
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '5'),
    euFupLimit: () => `7,8 ${t.U54O(gBMoMsg)}`,
  },
  [MobileM2MAddonCode.L]: {
    downloadSpeed: () => t.B69Q(kBitsPerSecondMsg, '512'),
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '10'),
    euFupLimit: () => `11 ${t.U54O(gBMoMsg)}`,
  },
  [MobileM2MAddonCode.fiveG]: {
    downloadSpeed: () => t.IJNS(mBitsPerSecondMsg, '50'),
    uploadSpeed: () => t.IJNS(mBitsPerSecondMsg, '100'),
    euFupLimit: () => `28 ${t.U54O(gBMoMsg)}`,
  },
  [FiveGMobileBroadbandProductCode.MBB_1000_M]: {
    euFupLimit: () => `73 ${t.U54O(gBMoMsg)}`,
  },
  [FiveGMobileBroadbandProductCode.MBB_600_M]: {
    euFupLimit: () => `60 ${t.U54O(gBMoMsg)}`,
  },
  [FiveGMobileBroadbandProductCode.MBB_300_M]: {
    euFupLimit: () => `${formatNumber(53.5)} ${t.U54O(gBMoMsg)}`,
  },
  [FiveGMobileBroadbandProductCode.MBB_100_M]: {
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
  },
  [MobileBroadbandFourGProductCodes.ONE_FIFTY]: {
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
  },
  [MobileBroadbandFourGProductCodes.FIFTY]: {
    euFupLimit: () => `${formatNumber(34)} ${t.U54O(gBMoMsg)}`,
  },
  [MobileBroadbandFourGProductCodes.TEN]: {
    euFupLimit: () => `${formatNumber(22.5)} ${t.U54O(gBMoMsg)}`,
  },
  [OldVoiceProductCode.VOICE_1000_M]: {
    euFupLimit: () => `${formatNumber(73)} ${t.U54O(gBMoMsg)}`,
  },
  [OldVoiceProductCode.VOICE_600_M]: {
    euFupLimit: () => `${formatNumber(66.5)} ${t.U54O(gBMoMsg)}`,
  },
  [OldVoiceProductCode.VOICE_300_M]: {
    euFupLimit: () => `${formatNumber(53.5)} ${t.U54O(gBMoMsg)}`,
  },
  [OldVoiceProductCode.VOICE_100_M]: {
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
  },
  [OldVoiceProductCode.VOICE_10_M]: {
    euFupLimit: () => `${formatNumber(44)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_1000_M]: {
    euFupLimit: () => `${formatNumber(58.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_600_M]: {
    euFupLimit: () => `${formatNumber(53.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_300_M]: {
    euFupLimit: () => `${formatNumber(53.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_200_M]: {
    euFupLimit: () => `${formatNumber(53.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_100_M]: {
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_50_M]: {
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_4G_50_M]: {
    euFupLimit: () => `${formatNumber(45.5)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_10_M]: {
    euFupLimit: () => `${formatNumber(35)} ${t.U54O(gBMoMsg)}`,
  },
  [YrityspakettiProductCode.VOICE_2_M]: {
    euFupLimit: () => `${formatNumber(26)} ${t.U54O(gBMoMsg)}`,
  },
  [FiveGVoiceProductCode.Voice1000Mbps]: {
    euFupLimit: () => `${formatNumber(80)} ${t.U54O(gBMoMsg)}`,
  },
  [FiveGVoiceProductCode.Voice600Mbps]: {
    euFupLimit: () => `${formatNumber(66.5)} ${t.U54O(gBMoMsg)}`,
  },
  [FiveGVoiceProductCode.Voice300Mbps]: {
    euFupLimit: () => `${formatNumber(58.5)} ${t.U54O(gBMoMsg)}`,
  },
  [VoiceYrityspuheLiteProductCode.VoiceYrityspuheLite300M]: {
    euFupLimit: () => '',
  },
  [VoiceYrityspuheLiteProductCode.VoiceYrityspuheLite100M]: {
    euFupLimit: () => '',
  },
  [VoiceYrityspuheLiteProductCode.VoiceYrityspuheLite50M]: {
    euFupLimit: () => '',
  },
};

export enum MbbSubscriptionSelectionSectionId {
  WIFI_SUBS_ID = 'wifi_subs',
  YRITYSDATA_SUBS_ID = 'yritysdata_subs',
}
